<template>
  <a-modal :width="`${option.autoCropWidth * (clipOption.zoom || 1) + 200}px`" v-model="showClip" title="裁剪" @ok="uploadImg()">
    <span class="close-modal-icon" slot="closeIcon"></span>
    <div>
      <div class="cropper-content" :style="{zoom: clipOption.zoom}">
        <!-- 剪裁框 -->
        <div class="cropper" :style="{height:`${option.autoCropHeight + 100}px`}">
          <vue-cropper
            ref="cropper"
            :img="imgFile"
            :outputSize="option.size"
            :outputType="option.outputType"
            :info="option.info"
            :full="option.full"
            :canMove="option.canMove"
            :canMoveBox="option.canMoveBox"
            :original="option.original"
            :autoCrop="option.autoCrop"
            :autoCropWidth="option.autoCropWidth"
            :autoCropHeight="option.autoCropHeight"
            :fixedBox="option.fixedBox"
            @realTime="realTime"
            :fixed="option.fixed"
            :fixedNumber="option.fixedNumber"
            :enlarge="option.enlarge"
          ></vue-cropper>
        <!-- <vueCropper ref="cropper" :img="option.img" :outputSize="option.size" :outputType="option.outputType"></vueCropper> -->
        </div>
        <!-- 预览框 -->
        <!-- <div class="show-preview" :style="{'width': '500px', 'height': '400px', 'overflow': 'hidden', 'margin': '0 25px', 'display':'flex', 'align-items' : 'center'}">
          <div :style="previews.div" class="preview">
            <img :src="previews.url" :style="previews.img">
          </div>
        </div> -->
      </div>
      <div class="footer-btn">
        <!-- 缩放旋转按钮 -->
        <div class="scope-btn">
          <a-button type="primary" @click="changeScale(1)" style="margin-right:20px">放大</a-button>
          <a-button type="primary" @click="changeScale(-1)" style="margin-right:20px">缩小</a-button>
          <a-button type="primary" @click="rotateLeft" style="margin-right:20px">逆时针旋转</a-button>
          <a-button type="primary" @click="rotateRight" style="margin-right:20px">顺时针旋转</a-button>
        </div>
        <!-- 确认上传按钮 -->
        <div class="upload-btn">
          <!-- <el-button type="primary" @click="uploadImg('blob')">上传</el-button> -->
          <!-- <a-button type="primary" :disabled="isDisabled" @click="uploadImg()">上传</a-button> -->
        </div>
      </div>
    </div>
  </a-modal>
</template>

<script>
// console.log(VueCropper);

export default {
  name: 'ImageClip',
  data () {
    return {
      showClip: false,
      previews: {}, // 预览数据
      option: {
        img: '', // 裁剪图片的地址  (默认：空) url 地址 / base64 / blob
        outputSize: 1, // 裁剪生成图片的质量  (默认:1)
        full: false, // 是否输出原图比例的截图 选true生成的图片会非常大  (默认:false)
        outputType: 'png', // 裁剪生成图片的格式  (默认:jpg)
        canMove: true, // 上传图片是否可以移动  (默认:true)
        original: false, // 上传图片按照原始比例渲染  (默认:false)
        canMoveBox: true, // 截图框能否拖动  (默认:true)
        autoCrop: true, // 是否默认生成截图框  (默认:false)
        autoCropWidth: this.clipOption.autoCropWidth, // 默认生成截图框宽度  (默认:80%)
        autoCropHeight: this.clipOption.autoCropHeight, // 默认生成截图框高度  (默认:80%)
        fixedBox: true, // 固定截图框大小 不允许改变  (默认:false)
        fixed: true, // 是否开启截图框宽高固定比例  (默认:true)
        fixedNumber: this.clipOption.fixedNumber, // 截图框比例  (默认:[1:1])
        enlarge: 1,
        info: this.clipOption.info
      },
      isDisabled: false,
      downImg: '#'
    }
  },
  props: {
    // type: {
    //   type: String,
    //   default: ''
    // },
    clipOption: {
      type: Object,
      default: () => {
        return {
          autoCropWidth: 430,
          autoCropHeight: 269,
          fixedNumber: [430, 269],
          zoom: 1,
          info: true
        }
      }
    },
    imgFile: {
      type: null,
      default: ''
    },
    // fixedNumber: {
    //   type: Array,
    //   default: () => [1, 1]
    // },
    fileName: {
      type: String,
      default: ''
    },
    onClipSuccess: {
      type: Function,
      default: () => {
        return new Promise((resolve, reject) => {
          resolve('ok')
        })
      }
    }
  },
  watch: {
    imgFile (val) {
      this.imgFile = val
    }
  },
  created () {
  },
  methods: {
    changeScale (num) {
      // 图片缩放
      num = num || 1
      this.$refs.cropper.changeScale(num)
    },
    rotateLeft () {
      // 向左旋转
      this.$refs.cropper.rotateLeft()
    },
    rotateRight () {
      // 向右旋转
      this.$refs.cropper.rotateRight()
    },
    realTime (data) {
      // 实时预览
      this.previews = data
    },
    uploadImg (type) {
      // 将剪裁好的图片回传给父组件
      this.showClip = false
      const that = this
      this.$refs.cropper.getCropData(data => {
        that.$emit('upload', data, that.fileName)
      })
    }
  }
}
</script>
<style scoped>
.cropper-content {
  display: flex;
  display: -webkit-flex;
  justify-content: flex-end;
  -webkit-justify-content: flex-end;
}
.cropper-content .cropper {
  width: 100%;
}
.cropper-content .show-preview {
  flex: 1;
  -webkit-flex: 1;
  display: flex;
  display: -webkit-flex;
  justify-content: center;
  -webkit-justify-content: center;
  overflow: hidden;
  border: 1px solid #cccccc;
  background: #cccccc;
  margin-left: 40px;
}
.preview {
  overflow: hidden;
  border: 1px solid #cccccc;
  background: #cccccc;
}
.footer-btn {
  margin-top: 30px;
  display: flex;
  display: -webkit-flex;
  justify-content: flex-end;
  -webkit-justify-content: flex-end;
}
.footer-btn .scope-btn {
  width: 250px;
  display: flex;
  display: -webkit-flex;
  justify-content: space-between;
  -webkit-justify-content: space-between;
}
.footer-btn .upload-btn {
  flex: 1;
  -webkit-flex: 1;
  display: flex;
  display: -webkit-flex;
  justify-content: center;
  -webkit-justify-content: center;
}
.footer-btn .btn {
  outline: none;
  display: inline-block;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  -webkit-appearance: none;
  text-align: center;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  outline: 0;
  margin: 0;
  -webkit-transition: 0.1s;
  transition: 0.1s;
  font-weight: 500;
  padding: 8px 15px;
  font-size: 12px;
  border-radius: 3px;
  color: #fff;
  background-color: #67c23a;
  border-color: #67c23a;
}
</style>
